import axios from 'axios';

export class APIClient {
    #endpoint
    #baseUrl
    #http
    #apiV2

    constructor(endpoint = null, baseUrl = '', session = null, server = null, apiV2 = false) {
        this.#endpoint = endpoint ?? null;
        this.#baseUrl = baseUrl;
        this.#apiV2 = apiV2;
        this.setSession(session, server);
    }

    setSession(session, server) {
        const conf = { headers: {} };
        if (session !== null) {
            conf.headers['X-BT2-Session'] = session;
        }
        if (server !== null) {
            conf.headers['X-BT2-TravianUrl'] = server;
        }
        this.#http = axios.create(conf);
    }

    #buildUrl(method) {
        return this.#baseUrl + `/api/${this.#apiV2 ? 'v2' : 'v1'}/${this.#endpoint ?? ''}${this.#endpoint === null ? '' : '/'}${method}`
    }

    /**
     * @returns Promise<any>
     */
    async get(method, appendix = null, config = undefined) {
        return this.#http.get(this.#buildUrl(method + (appendix ?? '')), config).then(response => response.data);
    }

    /**
     * @returns Promise<any>
     */
    async getWithQuery(method, query, config = undefined) {
        return this.get(method, '?' + (new URLSearchParams(query ?? {})).toString(), config);
    }

    /**
     * @returns Promise<any>
     */
    async getFromCache(cacheKey) {
        return this.#http.get('/cache/v2/' + cacheKey + '.json').then(response => response.data);
    }

    /**
     * @returns Promise<any>
     */
    async post(method, data, config = undefined) {
        return this.#http.post(this.#buildUrl(method), data, config).then(response => response.data);
    }

    /**
     * @returns Promise<any>
     */
    async put(method, data, config = undefined) {
        return this.#http.put(this.#buildUrl(method), data, config).then(response => response.data);
    }

    /**
     * @returns Promise<any>
     */
    async patch(method, data, config = undefined) {
        return this.#http.patch(this.#buildUrl(method), data, config).then(response => response.data);
    }

    /**
     * @returns Promise<any>
     */
    async delete(method, data = {}, config = undefined) {
        return this.#http.delete(this.#buildUrl(method) + '?' + (new URLSearchParams(data) ?? {}).toString(), config).then(response => response.data);
    }
}

export const API = new APIClient();
export const APIv2 = new APIClient(null, '', null, null, true);

export default API;
